import { render, staticRenderFns } from "./LabInternalExamParameter.vue?vue&type=template&id=76ee6fe6"
import script from "./LabInternalExamParameter.vue?vue&type=script&lang=js"
export * from "./LabInternalExamParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports